<template>
  <v-app>
    <!-- navigation drawer -->
    <v-navigation-drawer :width="300" v-if="appStore.authToken">
      <v-list nav density="compact">
        <v-list-item title="WWSRA" subtitle="Lynx"></v-list-item>
        <v-divider></v-divider>
        <v-list-group class="admin-name">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              :title="appStore.adminName"
            ></v-list-item>
          </template>
          <v-list-item
            title="Log Out"
            @click="appStore.logOut()"
          ></v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-item to="/" title="Dashboard" prepend-icon="mdi-view-dashboard"></v-list-item>
        <v-list-group value="Settings">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-cog"
              title="Settings"
            ></v-list-item>
          </template>
          <v-list-item to="/settings/show-regions" title="Show Regions"></v-list-item>
          <v-list-item to="/settings/show-types" title="Show Types"></v-list-item>
          <v-list-item to="/settings/show-years" title="Show Years"></v-list-item>
          <v-list-item to="/settings/board-members" title="Board Members"></v-list-item>
          <v-list-item to="/settings/staff" title="Staff"></v-list-item>
          <v-list-item to="/settings/global-settings" title="Global Settings"></v-list-item>
          <v-list-item to="/settings/system-emails" title="System Emails"></v-list-item>
          <v-list-item to="/settings/actions" title="Actions"></v-list-item>
        </v-list-group>
        <v-list-item to="/shows" title="Shows" prepend-icon="mdi-ski"></v-list-item>
        <!-- <v-list-item to="/liability-forms" title="Liability Forms" prepend-icon="mdi-file-sign"></v-list-item> -->
        <v-list-item to="/bulk-jobs" title="Bulk Jobs" prepend-icon="mdi-factory"></v-list-item>
        <v-list-group value="Power Data">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-lightning-bolt"
              title="Power Data"
            ></v-list-item>
          </template>
          <v-list-item to="/power-data/shows" title="Shows" color="pink"></v-list-item>
          <v-list-item to="/power-data/members" title="Members" color="deep-orange"></v-list-item>
          <v-list-item to="/power-data/retailers" title="Retailers" color="cyan"></v-list-item>
          <v-list-item to="/settings/member-brands" title="Member Brands (Lines)"></v-list-item>
        </v-list-group>
        <!-- <v-list-group value="Reports">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-table"
              title="Reports"
            ></v-list-item>
          </template>
          <v-list-item to="/reports/members" title="Member Reports"></v-list-item>
          <v-list-item to="/reports/retailers" title="Retailer Reports"></v-list-item>
        </v-list-group>
        <v-list-item to="/pages" title="Pages" prepend-icon="mdi-file-outline"></v-list-item>
        <v-list-item to="/files" title="Files" prepend-icon="mdi-multimedia"></v-list-item> -->
      </v-list>
    </v-navigation-drawer> <!-- /navigation drawer -->
    <v-main class="default-layout">
      <loader v-if="appStore.loading"></loader>
      <div class="view-content" v-if="!appStore.pageErrorStatus.error">
        <!-- status bar -->
        <status-bar v-if="!appStore.dialogActive" :show-email-intercept="true"></status-bar><!-- status bar -->
        <router-view :key="appStore.routerKey"/>
      </div>
      <PageError
        v-else
        :status="appStore.pageErrorStatus.status"
        :status-text="appStore.pageErrorStatus.text"
      ></PageError>
    </v-main>
  </v-app>
</template>

<script setup>
  import { useAppStore } from '@/stores/app'
  const appStore = useAppStore()
  const router = useRouter(),
    routerKey = ref(0)


  onMounted(() => {
    const token = appStore.authToken
    if (!token)  {
      appStore.clearAuth()
      router.push('/log-in')
    }
  })
</script>

<style lang="scss">
.default-layout {

  .view-content {
    padding: 2rem;
  }

}
</style>
